<template>
  <div>
    <button @click="open"
            class="mt-2 py-1 ml-4 px-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-700 font-medium hover:bg-gray-100">
      <i class="fa fa-pencil" aria-hidden="true"></i>
      Edit
    </button>

    <button @click="showClone = true"
            class="mt-2 py-1 ml-4 px-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-700 font-medium hover:bg-gray-100">
      <i class="fa fa-clone" aria-hidden="true"></i>
      Clone
    </button>

    <portal to="modal" v-if="showModal">
      <modal @close="showModal = false">

        <div class="grid grid-cols-1 gap-4">

          <input-text v-model="name">Gruppenname</input-text>

          <div>
            <label>
              User dürfen Schreibtisch selbst reservieren:
              <input type="checkbox" v-model="self_reservations">
            </label>
          </div>

          <toggle-group v-model="allow_desk_edit">
            Nutzer dürfen in der App die Schreibtischzuordnung ändern
          </toggle-group>

          <toggle-group v-model="has_staff_search">Mitarbeitersuche</toggle-group>

          <toggle-group v-model="has_conference_rooms">Konferenzräume</toggle-group>

          <toggle-group v-model="show_bookable_bookings">Buchungen außer Schreibtisch im Team anzeigen.</toggle-group>

          <toggle-group v-model="avatar_upload">Avatar kann von der App hochgeladen werden.</toggle-group>

          <toggle-group v-model="disableHolidaysBooking">Feiertagsbuchungen Deaktivieren</toggle-group>

          <toggle-group v-model="hasCheckIn">Check-In mit QR code</toggle-group>

          <input-text v-model="publicHolidayCalendar">Feiertagskalender</input-text>

          <toggle-group v-model="noticeFieldConferenceRoomBookingIsRequired">Das Notizfeld bei der Buchung von
            Konferenzräumen ist Pflichtfeld
          </toggle-group>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="max_users" class="text-gray-700 block"
              >Max. Nutzer</label
              >
              <input
                  id="max_users"
                  type="number"
                  v-model="max_users"
                  class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:ring-opacity-50 w-full py-2 px-3"
              />
            </div>

            <div>
              <label for="max_desks" class="text-gray-700 block"
              >Max. Schreibtische</label
              >
              <input
                  id="max_desks"
                  type="number"
                  v-model="max_desks"
                  class="rounded-lg border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:ring-opacity-50 w-full py-2 px-3"
              />
            </div>
          </div>

          <button class="mt-4 px-4 py-2 rounded border border-blue-500 bg-blue-200" @click="confirm">save
          </button>

        </div>
      </modal>
    </portal>

    <portal to="modal" v-if="showClone">
      <modal @close="showClone = false">

        <template v-slot:header>Gruppe clonen</template>

        <p>
          1. Erstelle eine neue Gruppe, die den gleichen Inhalt haben soll wie die Vorlage<br>
          2. Gehe in diese Gruppe, drücken den Clonen Knopf.<br>
          Der Inhalt von $vorlage wird jetzt in diese Gruppe übertragen. HTH
        </p>

        <button-primary @click="clone">Gruppe von Beispielgruppe aus klonen!</button-primary>
      </modal>
    </portal>
  </div>
</template>

<script>
import Modal from "../Modal";
import Toggle from "../UI/Toggle";
import ToggleGroup from "../UI/ToggleGroup";
import BookableCategoryEdit from "./BookableCategoryEdit.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import InputText from "../UI/InputText.vue";
import InputField from "../UI/InputField.vue";

export default {
  name: "EditGroup",

  components: {
    InputText,
    ButtonPrimary,
    BookableCategoryEdit,
    ToggleGroup,
    Toggle,
    InputField,
    Modal,
  },

  props: ["group"],

  data: () => ({
    showModal: false,
    showClone: false,
    self_reservations: false,
    has_conference_rooms: false,
    has_staff_search: false,
    allow_desk_edit: false,
    name: "",
    show_bookable_bookings: false,
    avatar_upload: false,
    max_users: 0,
    max_desks: 0,
    disableHolidaysBooking: false,
    publicHolidayCalendar: "de",
    hasCheckIn: false,
    noticeFieldConferenceRoomBookingIsRequired: false
  }),
  methods: {
    open() {
      this.self_reservations = this.group.self_reservations;
      this.allow_desk_edit = this.group.allow_desk_edit;
      this.has_conference_rooms = this.group.has_conference_rooms;
      this.has_staff_search = this.group.has_staff_search;
      this.name = this.group.name;
      this.show_bookable_bookings = this.group.show_bookable_bookings;
      this.avatar_upload = this.group.avatar_upload;
      this.showModal = true;
      this.disableHolidaysBooking = this.group.disable_holidays_booking;
      this.publicHolidayCalendar = this.group.public_holiday_calendar;
      this.hasCheckIn = this.group.has_check_in;
      this.noticeFieldConferenceRoomBookingIsRequired = this.group.notice_field_conference_room_booking_is_required;
      this.max_users = this.group.max_users;
      this.max_desks = this.group.max_desks;
    },
    confirm() {
      this.$http
          .post(`/super/groups/${this.group.id}`, {
            _method: 'put',
            self_reservations: this.self_reservations,
            has_conference_rooms: this.has_conference_rooms,
            has_staff_search: this.has_staff_search,
            allow_desk_edit: this.allow_desk_edit,
            show_bookable_bookings: this.show_bookable_bookings,
            avatar_upload: this.avatar_upload,
            name: this.name,
            disable_holidays_booking: this.disableHolidaysBooking,
            public_holiday_calendar: this.publicHolidayCalendar,
            has_check_in: this.hasCheckIn,
            notice_field_conference_room_booking_is_required: this.noticeFieldConferenceRoomBookingIsRequired,
            max_users: this.max_users,
            max_desks: this.max_desks,
          })
          .then(() => {
            this.showModal = false;
            location.reload();
          })
          .catch(error => {
            this.$root.$emit('error', error);
          });
    },
    clone() {
      this.$http
          .post(`/super/groups/${this.group.id}`, {
            _method: 'put',
            clone: 'clone',
          })
          .then(() => {
            this.showClone = false;
            location.reload();
          })
          .catch(error => {
            alert("Clonen Fehlgeschlagen");
            this.$root.$emit('error', error);
          });
    }
  }
}
</script>

<style scoped>

</style>
